/* global window */

let _context;

try {
  _context = window;
} catch (e) {
  _context = global;
}

const context = _context;

export default context;



// WEBPACK FOOTER //
// ./js/util/context.js